import type { AppDefinition, ComingApp } from '../types';

export const ALL_APPS: AppDefinition[] = [
  {
    id: 'adm',
    name: 'GS-Admin',
    desc: 'Utilisateurs, syncs SOFI, logs ETL',
    icon: 'Settings2',
    iconBg: '#eff6ff',
    iconColor: '#2563eb',
    platform: 'azure',
    status: 'dev',
    url: 'https://admin.groupesignalisation.ca',
    adminOnly: true,
  },
  {
    id: 'inv',
    name: 'GS-Inventaire',
    desc: 'Stocks & EPI — 11 régions',
    icon: 'Package',
    iconBg: '#fdf2f3',
    iconColor: '#D92231',
    platform: 'azure',
    status: 'integration',
    url: 'https://inventaire.groupesignalisation.ca',
  },
  {
    id: 'anl',
    name: 'GS-Analytics',
    desc: 'KPI, CAPEX, BI multi-source',
    icon: 'BarChart3',
    iconBg: '#eff6ff',
    iconColor: '#2563eb',
    platform: 'azure',
    status: 'dev',
    url: '',
  },
  {
    id: 'ops',
    name: 'GS-Ops',
    desc: 'GPS, punch, bons de travail',
    icon: 'HardHat',
    iconBg: '#f0fdf4',
    iconColor: '#16a34a',
    platform: 'firebase',
    status: 'test',
    url: '',
  },
  {
    id: 'shp',
    name: 'GS-ShopHub',
    desc: 'Facturation mécanique B2B',
    icon: 'Wrench',
    iconBg: '#fdf4ff',
    iconColor: '#a21caf',
    platform: 'azure',
    status: 'poc',
    url: '',
  },
  {
    id: 'for',
    name: 'GS-Formation',
    desc: 'LMS, certifications employés',
    icon: 'GraduationCap',
    iconBg: '#f5f3ff',
    iconColor: '#7c3aed',
    platform: 'firebase',
    status: 'test',
    url: '',
  },
  {
    id: 'sst',
    name: 'GS-ZoneSecur',
    desc: 'SST, prévention, rapports terrain',
    icon: 'ShieldCheck',
    iconBg: '#ecfdf5',
    iconColor: '#059669',
    platform: 'firebase',
    status: 'prod',
    url: '',
  },
  {
    id: 'flt',
    name: 'GS-Flotte',
    desc: 'Maintenance & TCO, 500 véhicules',
    icon: 'Truck',
    iconBg: '#fffbeb',
    iconColor: '#d97706',
    platform: 'azure',
    status: 'dev',
    url: '',
  },
  {
    id: 'iot',
    name: 'UF WebEditor',
    desc: 'Config AFAD, IoT, firmware OTA',
    icon: 'Cpu',
    iconBg: '#fff8ed',
    iconColor: '#F99D27',
    platform: 'firebase',
    status: 'prod',
    url: '',
  },
  {
    id: 'dep',
    name: 'GS-Dépenses',
    desc: 'Notes de frais & approbation',
    icon: 'Receipt',
    iconBg: '#fdf2f8',
    iconColor: '#c026d3',
    platform: 'azure',
    status: 'poc',
    url: '',
  },
  {
    id: 'sal',
    name: 'GS-Salus',
    desc: 'Inspections SST & risques EPI',
    icon: 'HeartPulse',
    iconBg: '#fef2f2',
    iconColor: '#dc2626',
    platform: 'firebase',
    status: 'dev',
    url: '',
  },
];

export const COMING_APPS: ComingApp[] = [
  { id: 'rec', name: 'GS-Recrutement', desc: 'Remplace Appy Here' },
  { id: 'tkt', name: 'GS-Tickets', desc: 'Bugs et améliorations' },
];

export function getAppById(id: string): AppDefinition | undefined {
  return ALL_APPS.find((a) => a.id === id);
}
